import { match } from "ts-pattern";
import ImageMediaCard from "./ImageMediaCard";
import LinkMediaCard from "./LinkMediaCard";
import VideoMediaCard from "./VideoMediaCard";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import { EMediaKind } from "common/enums/Project/Config/Media/EMediaKind";

type IProps = {
	media: MediaResponseResource;
	onOpen: (mediaResponseResource: MediaResponseResource) => void;
};

export default function MediaCard(props: IProps) {
	return match(props.media.kind)
		.with(EMediaKind.VIDEO, () => <VideoMediaCard {...props} />)
		.with(EMediaKind.IMAGE, () => <ImageMediaCard {...props} />)
		.with(EMediaKind.URL, () => <LinkMediaCard {...props} />)
		.exhaustive();
}
